"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Footer = exports.Copyright = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var styles_1 = require("@material-ui/core/styles");
var link_1 = __importDefault(require("../../link"));
var useStyles = styles_1.makeStyles(function (theme) { return ({
    footer: {
        padding: theme.spacing(2)
    }
}); });
exports.Copyright = function (_a) {
    var company = _a.company, sha = _a.sha;
    var shaOut = sha ? (sha.link ? (react_1["default"].createElement(link_1["default"], { external: true, to: sha.link }, sha.sha)) : (sha)) : null;
    return (react_1["default"].createElement(core_1.Typography, { variant: "body2", color: "textSecondary", align: "center" },
        "Copyright \u00A9 ",
        company,
        " ",
        new Date().getFullYear(),
        react_1["default"].createElement("br", null),
        react_1["default"].createElement("small", null, shaOut)));
};
exports.Footer = function (_a) {
    var children = _a.children;
    var classes = useStyles();
    return react_1["default"].createElement("footer", { className: classes.footer }, children);
};
exports["default"] = exports.Footer;
